import { createContext, useContext } from 'react';
export const NavbarContext = createContext({ height: 0 });
export const useNavbarContext = () => useContext(NavbarContext);
//# sourceMappingURL=NavbarContext.js.map